var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionAirPressure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 13 4-3v2a1 1 0 0 0 1-1V2h2v9a3 3 0 0 1-3 3v2l-4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 13-4-3v2a1 1 0 0 1-1-1V2h-2v9a3 3 0 0 0 3 3v2l4-3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14h-2V2h-2v12H9l3 4 3-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22v-2H4v2h16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionAirPressure);
export default __webpack_public_path__ + "static/media/ic_action_air_pressure.aae8f049ca33027e6059ef062fd9c9d2.svg";
export { ForwardRef as ReactComponent };